// @flow
import { CategoriasRutaActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    categoriaRuta: {},
    listaCategoriasRuta: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false
};

type CategoriasRutaAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { categoriaRuta?: {} | null, listaCategoriasRuta?: [] | null, loading?: boolean, +value ?: boolean };

const CategoriasRuta = (state: State = INIT_STATE, action: CategoriasRutaAction): any => {
    // console.log(action);
    switch (action.type) {
        case CategoriasRutaActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case CategoriasRutaActionTypes.GET_CATEGORIA_RUTA: {
                    return {
                        ...state,
                        categoriaRuta: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case CategoriasRutaActionTypes.LIST_CATEGORIAS_RUTA: {
                    return {
                        ...state,
                        listaCategoriasRuta: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case CategoriasRutaActionTypes.ADD_CATEGORIA_RUTA: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case CategoriasRutaActionTypes.UPDATE_CATEGORIA_RUTA: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case CategoriasRutaActionTypes.DELETE_CATEGORIA_RUTA: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case CategoriasRutaActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case CategoriasRutaActionTypes.GET_CATEGORIA_RUTA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        categoriaRuta: {},
                        loading: false,
                    };
                }
                case CategoriasRutaActionTypes.LIST_CATEGORIAS_RUTA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaCategoriasRuta: [],
                        loading: false,
                    };
                }
                case CategoriasRutaActionTypes.ADD_CATEGORIA_RUTA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case CategoriasRutaActionTypes.UPDATE_CATEGORIA_RUTA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case CategoriasRutaActionTypes.DELETE_CATEGORIA_RUTA: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case CategoriasRutaActionTypes.GET_CATEGORIA_RUTA:
            return { ...state, error: false, loading: true };
        case CategoriasRutaActionTypes.LIST_CATEGORIAS_RUTA:
            return { ...state, error: false, loading: true };
        case CategoriasRutaActionTypes.ADD_CATEGORIA_RUTA:
            return { ...state, error: false, loadingForm: true };
        case CategoriasRutaActionTypes.UPDATE_CATEGORIA_RUTA:
            return { ...state, error: false, loadingForm: true };
        case CategoriasRutaActionTypes.DELETE_CATEGORIA_RUTA:
            return { ...state, error: false, loading: true };
        case CategoriasRutaActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                categoriaRuta: {},
                listaCategoriasRuta: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default CategoriasRuta;
